import React from "react";
import { Component } from "react";
import { Button, Col,Form,InputGroup, Modal, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { withRouter } from "react-router";
import Select from "react-select";
import axiosInstance from "../../../axiosInstance";
import Onu from "../../components/Onu";
import StbForm from "../../components/StbForm";
import { logOut, make_select_data } from "../../helper";
import AsyncSelect from 'react-select/async'

const defaultProviderId = 10;
class UpdateTicket extends Component{


    constructor(props){
        super(props);
        this.fetch_ticket_by_id = this.fetch_ticket_by_id.bind(this);
        this.fetchStbs = this.fetchStbs.bind(this);
        this.fetchOnu = this.fetchOnu.bind(this);
        this.state = {
            id : this.props.match.params.id,
            consumer : {
                id : 1,
                account_id : "",
                first_name : "",
                second_name : "",
                personal_number : "",
                address : "",
                phone : "",
                sec_phone : "",
                city: ""
            },
            types_filters_array : [],
            stb_packages:[],
            internet_packages:[],
            internet_speeds_array: [],
            internet_providers_array: [],
            problems_array: [],
            stbs: [],
            onu : {
                odf_address : null,
            },
            selected_type : null,
            provider_id:defaultProviderId,
            martv_internet : false,
            martv_stb : false,
            ott_stb  :false,
            is_create_stb : false,
            is_create_internet : false,
            quantity : 1,
            addStb : {
                showModal : false,
                reference : React.createRef()
            },
            addOnu : {
                showModal: false,
                odf_name : "",
                odf_id : null,
                odf_address : null,
                internet_package_id: null,
                errors: {
                    odf_name : true
                }
            },
            main : {
                showModal : false,
                response : {
                    isInvalid : false,
                    message : "test"
                }
            }
        }
    }
    componentDidMount(){
        console.log(this.state.id);
        this.fetch_filter_types();
        this.fetch_tv_brands();
        this.fetch_internet_speeds();
        this.fetch_internet_providers();
        this.fetch_filter_stages();
        this.fetch_stb_packages();
        this.fetch_internet_packages();
        this.fetch_ticket_by_id();
    }

    OdfHasFreeSpace(odf_id){
        axiosInstance.get('gpon/odf/'+odf_id+'/has/space')
        .then(response => {
            let data = response.data.data
            console.log(data)
            this.setState({
                addOnu: {
                    ...this.state.addOnu,
                    odf_id:odf_id,
                    odf_name:data.odf_name,
                    errors: {
                        ...this.state.addOnu.errors,
                        odf_name:!data.passes,
                    },
                }
               
            })
        })
        .catch(err => {
            if (err.response.status === 401) {
                logOut(this.props);
            }
            if(err.response.status === 503){

            }
        })
    }

    fetch_ticket_by_id() {
        axiosInstance.get("tickets/" + this.props.match.params.id)
            .then(response => response.data.data)
            .then(data => {
                console.log(data)

                this.setState({
                    consumer : {
                        id : data.id,
                        account_id : data.account_id,
                        first_name : data.first_name,
                        second_name : data.second_name,
                        personal_number :data.personal_number,
                    },
                    provider_id: data.provider_id,
                    martv_internet : false,
                    martv_stb : false,
                    ott_stb  :false,
                    is_create_stb:data.is_create_stb,
                    is_create_internet:data.is_create_internet,
                    quantity : 1,
                    onu : data.onu,
                    stbs: data.stbs ? data.stbs : [],
                    selected_type : {
                        "value" : data.type_id,
                        "label" : data.type
                    }
                })
                this.fetch_type(data.type_id);
            })
            .catch(err => {

            })
    }

    fetch_type(type_id){
        axiosInstance.get('tickets/types/' + type_id)
        .then(response => response.data.data).
        then(data => {
            this.setState({
                is_create_internet : data.is_create_internet,
                is_create_stb : data.is_create_stb
            })
        })
        .catch(err => {

        })
    }

    loadOptions = () => {
        return axiosInstance.get('gpon/odf/like/address?address=' + this.state.odf_address)
            .then(response => {
                return response.data.data.data
            })
            .then(data => data.map(function(element){
                return {
                    'label' : element.address,
                    'value' : element.id
                }
            }))
            .catch(error => {
                console.log(error)
            })
    };

    fetch_filter_types() {
        axiosInstance.get('tickets/types/auth')
            .then(response => {
                this.setState({
                    types_filters_array: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                if (err?.response?.status === 401) {
                    logOut(this.props);
                }
            })

    }
    fetch_tv_brands() {
        axiosInstance.get('/tv_brands')
            .then(response => {
                this.setState({
                    tv_brands: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }
    fetch_internet_speeds() {
        axiosInstance.get('/internet_speeds')
            .then(response => {
                let speeds = make_select_data(response.data.data);
                let value = speeds[0];
                this.setState({
                    internet_speeds_array: speeds,
                    internet_speed: value
                })

            })
            .catch(err => {
                if (err?.response?.status === 401) {
                    logOut(this.props);
                }
            })
    }

    fetch_internet_providers() {
        axiosInstance.get('/internet_providers')
            .then(response => {
                let providers = make_select_data(response.data.data);
                this.setState({
                    internet_providers_array: providers,
                })

            })
            .catch(err => {
                if (err?.response?.status === 401) {
                    logOut(this.props);
                }
            })
    }

    fetch_filter_stages() {
        axiosInstance.get('tickets/stages/inside/')
            .then(response => {
                this.setState({
                    stages_filters_array: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }

    fetch_stb_packages(){
        axiosInstance.get('/billing/stb/packages/all')
            .then(response => {
                var array = [];
                response.data.data.forEach(function (element) {
                    array.push({
                        value: element.id,
                        label: element.name
                    })
                });
                this.setState({
                    stb_packages: array
                })
            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }

    fetch_internet_packages(){
        axiosInstance.get('/billing/internet/packages/all')
            .then(response => {
                var array = [];
                response.data.data.forEach(function (element) {
                    array.push({
                        value: element.id,
                        label: element.name
                    })
                });
                this.setState({
                    internet_packages: array
                })
            })
            .catch(err => {
                console.log(err.response)
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }


    addStb(){
        let stb = this.state.addStb.reference.current.state;
        let props = this.state.addStb.reference.current.props;
        axiosInstance.post('tickets/stbs/' +this.state.id,{
            stb_package_ids : stb.stb_package_ids,
            additional : stb.additional,
            tv_brand_id : stb.tv_brand_id
        })
        .then(response => response.data)
        .then(data => {
            this.fetchStbs();
            this.setState({
                addStb : {
                    ...this.state.addStb,
                    showModal : false
                }
            })
        })
        .catch(err => {

        })
    }

    addOnu(){
        console.log("here");
        console.log({
            "ticket_id" : this.state.id,
            "odf_id" : this.state.addOnu.odf_id,
            "odf_name" : this.state.addOnu.odf_name,
            "internet_package_id" : this.state.addOnu.internet_package_id
        })

        axiosInstance.post('tickets/onu/'+ this.state.id,{
            "odf_id" : this.state.addOnu.odf_id,
            "odf_name" : this.state.addOnu.odf_name,
            "internet_package_id" : this.state.addOnu.internet_package_id
        })
        .then(response => {
            this.setState({
                addOnu : {
                    ...this.state.addOnu,
                    showModal : false,
                    odf_name : "",
                    errors :{
                        odf_name : true
                    }
                }
            })
            this.fetchOnu();
        })
        .catch(err => {
            console.log(err);
        })
    }

    render_stbs(){

        let array = this.state.stbs.map((element,index) => {
            let reference = React.createRef(); 
            return <Form.Group as={Col} md="6">
                <StbForm
                        key={index }
                        index = {index} 
                        stb_packages = {this.state.stb_packages} 
                        tv_brands = {this.state.tv_brands}
                        exists = {true}
                        element = {element}
                        ref = {reference}
                        isEditable = {true}
                        ticket_id = {this.state.id}
                        update = {this.fetchStbs}
                    />
            </Form.Group>
        });

        return <Form.Row as={Col} md="12">
            {array}
        </Form.Row>
    }

    render_onu(){
        if(this.state.onu){
            return <Onu 
            element = {this.state.onu} 
            internet_packages = {this.state.internet_packages} 
            update = {this.fetchOnu}
            isEditable = {true} 
            />
        }
       return null;
    }

    updateTicket(){
        axiosInstance.put('tickets/'+ this.state.id,{
            type_id : this.state.selected_type?.value,
        })
        .then(response => response.data)
        .then(data => {
            this.setState({
                main : {
                    ...this.state.main,
                    showModal: false,
                    response : {
                        isInvalid : false,
                        message : ""
                    }
                }
            })
        })
        .catch(err => {
            if(err.response?.status === 422){
                let errors = err.response.data.errors
                var message = "";
                Object.keys(errors).map((key,_) => { 
                    let messages = errors[key].map((value,_) => {
                        message += value
                    })
                });
                this.setState({
                    main : {
                        ...this.state.main,
                        response :{
                            isInvalid : true,
                            message : message 
                        }
                    }
                })
            }
            // console.log(err);
        })
    }

    fetchStbs(){
        axiosInstance.get('tickets/stbs/' + this.state.id)
        .then(response => response.data.data)
        .then(data => {
            this.setState({
                stbs: data
            })
        })
        .catch(err => {
            console.log(err);
        })
    }

    fetchOnu(){
        axiosInstance.get('tickets/onu/' + this.state.id)
        .then(response => response.data.data)
        .then(data => {
            this.setState({
                onu: data
            })
        })
        .catch(err => {
            console.log(err);
        })
    }

    render(){
        let stbs = this.state.is_create_stb ? this.render_stbs() : null;
        let onu = this.state.is_create_internet ?  this.render_onu() : null;
        return (
            <div className="content-main">
                <Form.Row>
                        <Form.Group as={Col} md="2" >
                            <ToggleButtonGroup type="checkbox" value={this.state.provider_id} onChange={(e,d) => {
                                this.setState({
                                    provider_id:d.target.value
                                })
                            }}>
                                {this.state.provider_id == 9 && <ToggleButton variant="light" id="tbg-btn-1" value={9}>OTT</ToggleButton>}
                                {this.state.provider_id == 10 && <ToggleButton  variant="light" id="tbg-btn-2" value={10}>MARTV</ToggleButton>} 
                            </ToggleButtonGroup>
                        </Form.Group> 
                </Form.Row>
                <Form.Row >
                    <Form.Group as={Col} md="2" controlId="validationFormik03">
                        <Form.Label>საბილინგო ნომერი</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type="number"
                                name="account_id"
                                readOnly = {true}
                                value={this.state.consumer.account_id}   
                            />

                        </InputGroup>
                    </Form.Group>
                    <Form.Group as={Col} md="2" controlId="validationFormik01">
                            <Form.Label>სახელი</Form.Label>
                            <Form.Control
                                type="text"
                                name="first_name"
                                readOnly={true}
                                value={this.state.consumer.first_name}
                            />
                    </Form.Group>
                    <Form.Group as={Col} md="2" controlId="validationFormik02">
                            <Form.Label>გვარი</Form.Label>
                            <Form.Control
                                type="text"
                                name="second_name"
                                readOnly = {true}
                                value={this.state.consumer.second_name}
                            />     
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="validationFormik02">
                            <Form.Label>პირადი ნომერი</Form.Label>
                            <Form.Control
                                type="number"
                                name="personal_number"
                                readOnly={true}
                                value={this.state.consumer.personal_number}
                            />   
                    </Form.Group>
                </Form.Row>
                <Form.Row className="mg-top br-top">
                        <Form.Group as={Col} md="4">
                            <Form.Control
                                type="number"
                                name="type"
                                onChange={null}
                                hidden={true}
                            />
                            <Form.Label>ტიპი</Form.Label>
                            <Select
                                value = {this.state.selected_type} 
                                maxMenuHeight={170} 
                                menuPlacement = "bottom" 
                                options={this.state.types_filters_array} 
                                onChange={(e) => {
                                    this.setState({
                                        selected_type : e
                                    })
                                    this.fetch_type(e.value);
                                }} 
                            />
                        </Form.Group>
                        <Form.Group as={Col} className= "d-flex flex-row justify-content-end align-items-end">
                            <Button onClick = {() => {
                                this.setState({
                                    main : {
                                        ...this.state.main,
                                        showModal : true
                                    }
                                })
                            }}>რედაქტირება</Button>
                        </Form.Group>
                </Form.Row>
                {this.state.is_create_stb && <Form.Row className="mg-top br-top">
                    <Form.Group as={Col} md="4">
                        <Button variant = "success" onClick = {() => {
                            this.setState({
                                addStb : {
                                    ...this.state.addStb,
                                    showModal : true
                                }
                            })
                        }}><i class="fas fa-plus"></i></Button>
                    </Form.Group>
                    
                    {stbs}
                </Form.Row>}
                {this.state.is_create_internet && <Form.Row className="mg-top br-top">
                    {this.state.onu  == null && <Form.Group as={Col} md="4">
                        <Button variant = "success" onClick = {() => {
                            this.setState({
                                addOnu : {
                                    ...this.state.addOnu,
                                    showModal : true
                                }
                            })
                        }}><i class="fas fa-plus"></i></Button>
                    </Form.Group>}
                    {onu}
                </Form.Row>}
                <Modal
                    show={this.state.addStb.showModal} 
                    size = "lg"
                    centered
                    onHide = {() => {
                        this.setState({
                            addStb : {
                                ...this.state.addStb,
                                showModal : false
                            }
                        })
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>STB დამატება</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <StbForm
                            exists = {false}
                            isEditable = {true} 
                            stb_packages = {this.state.stb_packages} 
                            tv_brands = {this.state.tv_brands}
                            ref = {this.state.addStb.reference}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={(event) => {
                            this.addStb()
                        }} >
                            დამატება
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={this.state.main.showModal} 
                    size = "lg"
                    centered
                    onHide = {() => {
                        this.setState({
                            main : {
                                ...this.state.main,
                                showModal : false,
                                response : {
                                    isInvalid : false,
                                    message : ""
                                }
                            }
                        })
                    }}
                >
                    <Modal.Header closeButton>
                        <Form.Control
                            type="text"
                            name="role"
                            hidden={true}
                            isInvalid={this.state.main.response.isInvalid}
                            onChange={null}
                        />
                        <Form.Control.Feedback type="invalid" >
                            {this.state.main.response.message}
                        </Form.Control.Feedback>
                    </Modal.Header>
                    <Modal.Body>
                        დანამდვილებით გსურთ რედაქტირება?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={(event) => {
                            this.updateTicket()
                        }} >
                            კი
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={this.state.addOnu.showModal} 
                    size = "lg"
                    centered
                    onHide = {() => {
                        this.setState({
                            addOnu : {
                                ...this.state.addOnu,
                                showModal : false,
                                odf_name : "",
                                errors :{
                                    odf_name : true
                                }
                            }
                        })
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>ინტერნეტის დამატება</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Row>
                            <Form.Group as = {Col} md="12">
                                <Form.Label>INTERNET</Form.Label>
                            </Form.Group>
                            <Form.Group as={Col} md="4">
                                <Form.Label>ODF მისამართი</Form.Label>
                                <AsyncSelect
                                    loadOptions={this.loadOptions}
                                    onInputChange={(e) => {
                                        this.setState({
                                            odf_address: e
                                        })
                                    }}
                                    onChange = {(e) =>{
                                        this.OdfHasFreeSpace(e.value);
                                    }}
                                />
                            </Form.Group>
                            <Form.Group as={Col} md="3">
                                <Form.Label>ODF სახელი</Form.Label>
                                <Form.Control
                                        type="text"
                                        name="odf_name"
                                        isInvalid={Boolean(this.state.addOnu.errors.odf_name)}
                                        isValid={Boolean(!this.state.addOnu.errors.odf_name)}
                                        readOnly = {true}
                                        value={this.state.addOnu.odf_name}
                                    />
                            </Form.Group>
                            <Form.Group as={Col} md="4" >
                                <Form.Label>ჩასართავი პაკეტი</Form.Label>
                                <Select 
                                    options={this.state.internet_packages} 
                                    onChange={(e) => {
                                        this.setState({
                                            addOnu :{
                                                ...this.state.addOnu,
                                                internet_package_id : e.value
                                            }
                                        })
                                    }} 
                                    placeholder="აირჩიეთ" />
                            </Form.Group>
                        </Form.Row> 
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" onClick={(event) => {
                            this.addOnu()
                        }} >
                            დამატება
                        </Button>
                    </Modal.Footer>
                </Modal> 
            </div>
        );
    }
}

export default withRouter(UpdateTicket);